import gql from 'graphql-tag';

export const REMOVE_DIRECTORY = gql`
  mutation removeDirectory($directoryId: Int!) {
    directory {
      removeDirectory(directoryId: $directoryId)
    }
  }
`;
